import 'can-construct-super';
import Control from 'can-control';

import '@/js/lib/jquery.validate';
import '@/js/lib/jquery.maskedinput';
import {fancyboxOptions} from "@/js/helper/fancybox-options.js";



/**
 * Стандартный контроллер для форм
 **/

const FormBase = Control.extend(
    {
        defaults: {
            row: '.form-row',
            select: '.js-select',
            mask: '.js-mask',
            btnShow: '.js_form',
            reset: '[js-reset]',
            apiModel: '/local/ajax/forms/handler.php',
        }
    },
    {
        $element: undefined,
        init() {

            this.$element = $(this.element);
            //this.initSelect();
            //this.initMask();

           $.extend($.validator.messages, {
                required: "Пожалуйста, заполните это поле",
                remote: "Введите правильное значение",
                email: "Некорректный адрес e-mail",
                url: "Введите корректный URL",
                date: "Введите корректную дату",
                dateISO: "Введите корректную дату в формате ISO",
                number: "Введите число",
                digits: "Введите только цифры",
                creditcard: "Введите правильный номер кредитной карты",
                equalTo: "Введите такое же значение ещё раз",
                extension: "Загрузите изображение, документ или архив",
                maxlength: $.validator.format("Введите не больше {0} символов"),
                minlength: $.validator.format("Введите не менее {0} символов"),
                rangelength: $.validator.format(`Введите значение длиной от {0} до {1} символов`),
                range: $.validator.format("Введите число от {0} до {1}"),
                max: $.validator.format("Введите число меньше {0}"),
                min: $.validator.format("Введите число больше {0}")
            });

            /* $(this.options.btnShow).on('click', (el) => {

                 el.preventDefault();

                 let $element = $('.form-control');
                 $element.removeClass('error');

                 let $message = $('.error-message');
                 $message.attr('style', 'display:none')

                 const src = el.currentTarget.dataset.href || el.currentTarget.attributes.href.value,
                     type = src[0] !== "#" ? 'ajax' : 'inline';

                 $.fancybox.open({
                     src: src
                 });

             })*/

            this.validate();

        },

        validate() {
            const _ = this;
            this.validator = this.$element.validate({
                submitHandler: function(form) {
                  // alert('submitHandler');
                }
            });
        },

        submitForm() {

            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            $.ajax({
                //type: "POST",
                method: this.$element.attr('method') || 'post',
                dataType: 'json',
                url: this.options.apiModel,
                data: this.element.serialize(),
                success: this.checkAnswer.bind(this),
                error: this.checkAnswer.bind(this)
            });

        },

        checkAnswer(answer) {

            if (answer.status === 'success') {
                this.resetForm();
                this.success(answer)
            } else {
                this.success(answer)
            }

        },

        error(answer) {
            let errors = [];

            if (answer.errors) {
                for (let prop in answer.errors) {
                    if (!answer.errors.hasOwnProperty(prop)) continue;
                    let array = $.map(answer.errors[prop], (value) => {
                        return [value];
                    });
                    errors[prop] = array.join(" ");
                }
                this.validator.showErrors(errors);
            }
        },

        success(answer) {
            if (answer.redirect) {
                window.location.href = answer.redirect;
                return;
            }
            if (answer.reload) {
                window.location.reload();
                return;
            }

            if (answer.reset) {
                this.resetForm();
            }

            if (answer.popup) {
                $.fancybox.open({
                    src: answer.popup,
                    type: 'ajax',
                    opts: fancyboxOptions,
                });
            }

            if (answer.popup_text) {
                $.fancybox.close();
                $.fancybox.open(answer.popup_text);
            }
        },

        resetForm() {
            this.element.reset();
        },

        initMask() {
            this.element.find(this.options.mask).each((i, el) => {
                let $el = $(el);
                $el.mask($el.data("mask"), {
                    placeholder: "_"
                });

            });
        },

        'input focus'(el) {
            this.focus(el);
        },

        'textarea focus'(el) {
            this.focus(el);
        },

        'input blur'(el) {
            this.blur(el);
        },

        'textarea blur'(el) {
            this.blur(el);
        },

        focus(el) {
            let $el = $(el);
            $el.addClass("not-empty");
        },

        'textarea input'(el) {
            setTimeout(function () {
                el.style.cssText = 'height:auto; ';//padding-top:0; padding-bottom:0
                el.style.cssText = 'height:' + el.scrollHeight + 'px';
            }, 0);
        },

        blur(el) {
            let $el = $(el);

            setTimeout(() => {
                if (!$el.val()) {
                    $el.removeClass("not-empty");
                    $el.parent().removeClass("valid");
                } else {
                    $el.addClass("not-empty");
                }
            }, 0);
        },
        '{btnShow} click'(el, ev) {
            ev.preventDefault();

            this.validator.unhighlight('.form-control')

            const src = el.dataset.href || el.attributes.href.value,
                type = src[0] !== "#" ? 'ajax' : 'inline';

            $.fancybox.open({
                src: src,
                type: type,
                opts: fancyboxOptions
            });
        },
        '{reset} click'(el, ev) {
            ev.preventDefault();
            this.resetForm();
        },

    }
);

export default FormBase;